module.exports = __webpack_public_path__ + "img/lootbox-legendary.64dda375.jpg";